import type { GeneratedFunnelTemplate } from "schemas/generated/funnelTemplate";

import * as React from "react";

import { WebContainerTemplate } from "@/features/web-container/WebContainerTemplate";
import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";

import PreviewThumbnail from "./PreviewThumbnail";

export function GeneratedFunnelTemplateCardSkeleton() {
  return (
    <div className="border-0.5 border-border w-full rounded-xl shadow-selectable flex flex-col cursor-pointer h-[124px] hover:bg-menu-item-hover">
      <Skeleton className="h-full w-full rounded-xl" />
    </div>
  );
}

export default function GeneratedFunnelTemplateCard({
  template,
  onClick,
  isSelected,
}: {
  template: GeneratedFunnelTemplate;
  onClick: () => void;
  isSelected?: boolean;
}) {
  return (
    <div
      className={twMerge(
        "border-0.5 border-border w-full rounded-xl shadow-selectable flex flex-col cursor-pointer h-[124px] bg-sheethover:bg-menu-item-hover",
        isSelected && "border-black border-2",
      )}
      onClick={onClick}
    >
      <div className="h-1/2 w-full overflow-hidden bg-sheet p-2 pb-0 rounded-t-xl flex gap-5 h-full justify-center">
        {template.funnelTemplateSteps.map((page) => (
          <WebContainerTemplate key={page.id} template={page}>
            {({ templateRoute }) => (
              <PreviewThumbnail
                pageRoute={templateRoute}
                className="w-[80px] max-w-[85px] h-[120px]"
              />
            )}
          </WebContainerTemplate>
        ))}
      </div>

      <div className="h-1/2 p-3 flex flex-col gap-y-1 border-t-0.5 border-border justify-center bg-sheet rounded-b-xl">
        <div className="header-h4 line-clamp-1">{template.name}</div>
      </div>
    </div>
  );
}
